import {useMutation, useQueryClient} from 'react-query';
import PostMachineryAdvertisement from '.';
import {AxiosError} from 'axios';
import {toast} from 'react-toastify';

interface IPostMachineryAdvertisementProps {
  onSuccess?: (response: IAddedAdvertisementResponse) => void;
}

const usePostMachineryAdvertisement = ({
  onSuccess,
}: IPostMachineryAdvertisementProps) => {
  const queryClient = useQueryClient();

  const {isLoading, mutate} = useMutation({
    mutationFn: (payload: IMachineryAdvertisementPayload) => {
      return PostMachineryAdvertisement(payload);
    },

    onSuccess: data => {
      if (onSuccess) {
        onSuccess(data); // Passing the response to onSuccess
      }

      queryClient.invalidateQueries({queryKey: ['my-ads']}); // Invalidate personal ads
      queryClient.invalidateQueries({queryKey: ['get-store-lab-views']}); // Invalidate store ads
    },

    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, mutate};
};

export {usePostMachineryAdvertisement};
